import posthog from 'posthog-js';

export const initAnalytics = () => {
  try {
    const key = import.meta.env.VITE_POSTHOG_KEY;
    if (!key || typeof key !== 'string') return;
    posthog.init(key, { api_host: 'https://app.posthog.com' });
  } catch {
    // Не ломаем приложение при ошибке инициализации аналитики (например в Telegram WebView)
  }
};

export const track = (event: string, props?: object) => {
  try {
    if (typeof posthog.capture !== 'function') return;
    posthog.capture(event, props);
  } catch {
    // ignore
  }
};
